/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoAutomaticHandoverEmailInput = {
    clientMutationId?: string | null;
    shipmentSlug: string;
};
export type ShipmentAutomaticHandoverEmailMutationVariables = {
    input: infoAutomaticHandoverEmailInput;
};
export type ShipmentAutomaticHandoverEmailMutationResponse = {
    readonly infoAutomaticHandoverEmail: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ShipmentAutomaticHandoverEmailMutation = {
    readonly response: ShipmentAutomaticHandoverEmailMutationResponse;
    readonly variables: ShipmentAutomaticHandoverEmailMutationVariables;
};



/*
mutation ShipmentAutomaticHandoverEmailMutation(
  $input: infoAutomaticHandoverEmailInput!
) {
  infoAutomaticHandoverEmail(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoAutomaticHandoverEmailPayload",
    "kind": "LinkedField",
    "name": "infoAutomaticHandoverEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShipmentAutomaticHandoverEmailMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShipmentAutomaticHandoverEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "59ca458f5cce8c91102251f0cbefc63c",
    "id": null,
    "metadata": {},
    "name": "ShipmentAutomaticHandoverEmailMutation",
    "operationKind": "mutation",
    "text": "mutation ShipmentAutomaticHandoverEmailMutation(\n  $input: infoAutomaticHandoverEmailInput!\n) {\n  infoAutomaticHandoverEmail(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '38a01290035f3b762b789b311509af4b';
export default node;
